export const ICON_SIZE = 16

export const modalReportHeight = '23rem'
